module.exports = __webpack_public_path__ + "9d404af3a3708e13b05ff6eafe93929c.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1_variable/public/news/background_things_you_didnt_know.jpg
// module id = 455
// module chunks = 0